<template>
    <div class="detail-container">
        <my-popup title="会员详情" :zIndex="'3000'" width="1090" :flag="isShow" @close="close">
            <div class="myInfo">
                <div class="account">
                    <p style="margin-bottom:10px">{{data.pin}}</p>
                    <p>买家账号</p>
                </div>
                <div class="total">
                    <div>
                        <p class="num">{{data.buyTotalCount}}</p>
                        <p class="txt">购买次数</p>
                    </div>
                    <div>
                        <p class="num">{{data.buyTotalMoney}}</p>
                        <p class="txt">交易总额(元)</p>
                    </div>
                </div>
            </div>

            <ul class="tab">
                <li :class="{'active':tabActive == 1}" @click="tabActive=1">基础属性</li>
                <li :class="{'active':tabActive == 2}" @click="tabActive=2">历史订单</li>
                <li class="line"></li>
            </ul>

            <!-- 会员交易信息 -->
            <template v-if="tabActive == 1">
                <div class="info" v-if="data">
                    <h4> <span></span> 基本信息</h4>
                    <ul class="form">
                        <li class="item" style="width:35.33%">
                            买家姓名：{{data.fullName && data.fullName.substring(0, 20)}}
                        </li>
                        <li class="item center" style="width:33.33%">
                            手机号码：{{((data.mobile && data.mobile.substring(0, 20)) || '--' ) | mobileEllipsis}} <i></i>
                        </li>
                        <li class="item right" style="width:30%">
                            会员等级：
                            <el-select v-model="data.grade" placeholder="请选择">
                                <el-option :key="1" label="一星会员" :value="1"></el-option>
                                <el-option :key="2" label="二星会员" :value="2"></el-option>
                                <el-option :key="3" label="三星会员" :value="3"></el-option>
                                <el-option :key="4" label="四星会员" :value="4"></el-option>
                                <el-option :key="5" label="五星会员" :value="5"></el-option>
                            </el-select>
                        </li>
                        <li class="item w100">
                            详情地址：{{data.fullAddress}}
                        </li>
                        <li class="item w100">
                            会员标签：
                            <span class="label" v-for="item in data.labelList" :key="item.id">{{item.labelName}}</span>
                            <span class="add" @click="labelState = true">添加标签</span>
                        </li>
                    </ul>
                </div>

                <div class="info" v-if="data">
                    <h4> <span></span> 消费记录</h4>
                    <ul class="form">
                        <li class="item">
                            购买次数：{{data.buyTotalCount}}次
                        </li>
                        <li class="item center">
                            交易总额：{{data.buyTotalMoney}}元
                        </li>
                        <li class="item right">
                            取消次数：{{data.canceledNum}}次
                        </li>
                        <li class="item">
                            客单价：{{data.avgPrice}}
                        </li>
                        <li class="item center">
                            下单休眠天数：{{data.dormancyDays ? data.dormancyDays : '--'}}天
                        </li>
                        <li class="item right">
                            付款休眠天数：{{data.dormancyPayDays ? data.dormancyPayDays : '--'}}天
                        </li>
                    </ul>
                </div>
            </template>

            <!-- 历史订单 -->
            <template v-if="tabActive == 2">
                <table class="table" v-loading="loading">
                    <th>
                        <td>订单编号</td>
                        <td>实付金额（元）</td>
                        <td class="f2">下单时间</td>
                        <td>付款方式</td>
                        <td>订单状态</td>
                        <td>送货类型</td>
                        <td class="f2">收货地址</td>
                    </th>
                    <tbody>
                        <tr v-for="item in orderList" :key="item.id">
                            <td>{{item.orderId}}</td>
                            <td>{{item.orderPayment}}</td>
                            <td class="f2">{{item.orderStartTime}}</td>
                            <td>{{item.payType}}</td>
                            <td>{{item.orderStateRemark}}</td>
                            <td>{{item.deliveryType}}</td>
                            <td class="f2">{{item.fullAddress && item.fullAddress.substring(0, 30)}}</td>
                        </tr>
                    </tbody>
                </table>
                <div class="page">
                    <el-pagination
                        background
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :page-sizes="[10, 20, 30, 50 , 100]"
                        :page-size="searchForm.size"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="total"
                    ></el-pagination>
                </div>
            </template>
            
            <footer>
                <button class="cancel" @click="close">取消</button>
                <button class="confirm" @click="close">确定</button>
            </footer>
        </my-popup>
        <!-- 选择标签 -->
        <select-label
        :labelState="labelState"
        :selectIdsArr="data && data.labelList ? data.labelList.map(item => item.labelId) : []"
        @transferName4="transferName"
        ></select-label>
    </div>
</template>

<script>
import selectLabel from "@/components/select-label.vue";
import myPopup from "@/components/myPopup";
import { buyerOrders } from "@/api/shopBuyer";
import { batchInsertLabel } from "@/api/manage/memberListController";
import { relativeTimeRounding } from "moment";

export default {
  props: ["isShow", "data"],
  components: {
    myPopup,
    selectLabel,
  },
  data() {
    return {
      tabActive: 1,
      loading: false,
      total: 0,
      searchForm: {
        buyerId: 0,
        size: 10,
        current: 1,
      },
      orderList: null,
      labelState: false,
    };
  },
  watch: {
    data(newVal) {
      console.log(this.data);
      if (newVal && newVal.id !== this.searchForm.buyerId) {
      this.searchForm.current = 1;
      this.searchForm.size = 10;
      this.tabActive = 1;
        this.getOrderList();
      }
    },
  },
  methods: {
    // 获取历史订单列表
    getOrderList() {
      this.loading = true;
      this.searchForm.pin = this.data && this.data.pin;
      buyerOrders(this.searchForm).then((res) => {
        this.orderList = res && res.data.records;
        this.total = res && res.data.total;
        this.loading = false;
      });
    },
    // 分页变化
    handleSizeChange(val) {
      this.searchForm.size = val;
      this.searchForm.current = 1;
      this.getOrderList();
    },
    handleCurrentChange(val) {
      this.searchForm.current = val;
      this.getOrderList();
    },
    transferName(val) {
      console.log(val)
      var idArr = val.idArr;  
      console.log(this.data);
      this.data.labelList = this.data.labelList?this.data.labelList:[]
      // return
      var allList = this.data.labelList.map(item => item.labelId)
      var delIds = [];
      console.log('this.data.labelList', allList);
      allList.forEach(item => {
        if (idArr.indexOf(item) == '-1') {
          delIds.push(item)
        }
      })

      const params = {
        delLabelIdList: delIds,
        addLabelIdList: idArr,
        pins: [this.data.pin],
      };
      batchInsertLabel(params).then((res) => {
        if (res && res.code == 1) {
          const arr = [];
          this.data.labelList = [];
          // const oldIds = this.data.labelList.map((item) => item.labelId);
          val.selectArr &&
            val.selectArr.forEach((item) => {
              // if (!oldIds.includes(item.id)) {
                this.data.labelList.push({
                  labelName: item.labelName,
                  labelId: item.id,
                });
              // }
            });

        }
      });
      this.labelState = false;
    },
    close() {
      this.$emit("close");
    },
  },
};
</script>

<style scoped lang="scss">
.detail-container {
    z-index: 1000 !important;
    .myInfo {
        box-sizing: border-box;
        padding: 15px 0 8px 0;
        display: flex;
        justify-content: space-between;
        align-items: center;
        .account {
            p {
                margin: 0;
                &:first-child {
                    color: #333333;
                    font-size: 14px;
                    font-weight: bold;
                }
                &:last-child {
                    color: #999999;
                    font-size: 12px;
                    font-weight: 500;
                }
            }
        }
        &:last-child {
          color: #999999;
          font-size: 12px;
          font-weight: 500;
        }
      }
    }
    .total {
      display: flex;
      align-items: center;
      box-sizing: border-box;
      position: relative;
      div {
        box-sizing: border-box;
        padding: 8px 0;
        &:first-child {
          border-right: 1px solid #f3f3f3;
          padding-right: 57px;
        }
        &:last-child {
          padding-left: 44px;
        }
        p {
          margin: 0;
        }
        .num {
          color: #fe4d45;
          font-size: 20px;
          font-weight: bold;
        }
        .txt {
          color: #999999;
          font-size: 12px;
          font-weight: 500;
          margin-top: 8px
        }
      }
    }
  
  .tab {
    display: flex;
    align-items: flex-end;
    width: 100%;
    li {
      display: flex;
      justify-content: center;
      align-items: center;
      box-sizing: border-box;
      padding: 8px 25px;
      color: #666;
      font-size: 14px;
      font-weight: 400;
      border: 1px solid #dddddd;
      border-radius: 2px 2px 0px 0px;
      cursor: pointer;
      &.active {
        color: #fe4d45;
        border-bottom: none;
        border-top: 3px solid #fe4d45;
        border-radius: 4px 4px 0px 0px;
      }
    }
    .line {
      padding: 0;
      border: none;
      height: 1px;
      flex: 1;
      background-color: #dddddd;
    }
  }
  .info {
    margin-top: 20px;
    h4 {
      display: flex;
      align-items: center;
      box-sizing: border-box;
      padding-left: 12px;
      height: 32px;
      margin: 0;
      background-color: #fafafa;
      span {
        margin-right: 6px;
        width: 2px;
        height: 14px;
        background-color: #fe4d45;
      }
    }
    .form {
      box-sizing: border-box;
      padding: 20px 28px 20px 0px;
      .item {
        display: inline-block;
        width: 40.00%;
        margin-bottom: 12px;
        color: #333;
        font-size: 14px;
        font-weight: 400;
        .add {
          color: #fe4d45;
          font-size: 14px;
          font-weight: 400;
          cursor: pointer;
        }
        .label {
          padding: 4px;
          display: inline-block;
          border-radius: 5px;
          border: 1px solid #fe4d45;
          color: #fe4d45;
          font-size: 13px;
          margin-right: 4px;
        }
      }
      .right {
        width: 16.63%;
        // text-align: right;
      }
      .center {
        width: 43.33%;
        // text-align: center;
      }
      .item.w100 {
        width: 100%;
      }
    }
  }
  footer {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 20px;
    button {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 96px;
      height: 32px;
      border: none;
      outline: none;
      background-color: #fff;
      transition: all 0.2s;
      cursor: pointer;
      font-size: 14px;
      font-weight: 400;
      border-radius: 4px;
    }
    .cancel {
      border: 1px solid #cccccc;
      color: #333;
      margin-right: 10px;
      &:hover {
        border-color: #fe4d45;
        color: #fe4d45;
      }
    }
    .confirm {
      background: #fe4d45;
      color: #fff;
      &:hover {
        opacity: 0.8;
      }
    }
  }
  .table {
    width: 100%;
    margin-top: 20px;
    th {
      width: 100%;
      height: 40px;
      line-height: 38px;
      border: 1px solid #f3f3f3;
      box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.04);
      display: flex;
    }
    tbody {
      display: block;
      height: 304px;
      overflow: auto;
      &::-webkit-scrollbar {
        width: 8px;
        height: 10px;
      }
      &::-webkit-scrollbar-track {
        background: rgba(246, 246, 246, 1);
        border-radius: 2px;
      }
      &::-webkit-scrollbar-thumb {
        background: #ddd;
        border-radius: 10px;
      }
      &::-webkit-scrollbar-thumb:hover {
        background: #ddd;
      }
    }
    tr {
      display: flex;
      padding: 10px 0;
      min-height: 60px;
      border-bottom: 1px solid #f6f6f6;
      td {
        display: flex;
        align-items: center;
        justify-content: center;
      }
    }
    td {
      flex: 1;
    }
    .f2 {
      flex: 2;
    }
  }

// .el-dialog__wrapper{
//     z-index: 2000 !important;
// }
</style>